import baseApi from 'store/slices/api/baseApi'

const choreographersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getChoreographers: build.query({
            query: (query) => ({
                url: `choreographers/searchChoreographers?search=${query}`,
                method: 'GET',
            }),
        }),
        getChoreographersNames: build.query({
            query: () => ({
                url: `choreographers/names`,
                method: 'GET',
            }),
        }),
    }),
    overrideExisting: false,
})

export const {useGetChoreographersQuery, useGetChoreographersNamesQuery} =
    choreographersApi
export default choreographersApi
